import { Dispatch } from "redux";
import { AnswerDto } from "../../../models/dtos/answer.dto";
import { ErrorDto } from "../../../models/dtos/error.dto";
import { AnswerRequest } from "../../../models/requests/answer.request";
import { Errors } from "../../../utilities/errors";
import { acceptEtkRequest } from "../../userService/acceptEtk/repository";
import { getMeRequest } from "../../userService/getMe/repository";
import {
  ANSWER_FAIL,
  ANSWER_RESET,
  ANSWER_START,
  ANSWER_SUCCESS,
} from "./constants";
import { answerRequest } from "./repository";
import {
  AnswerFailAction,
  AnswerResetAction,
  AnswerStartAction,
  AnswerSuccessAction,
} from "./types";

const answerStartAction = (): AnswerStartAction => {
  return {
    type: ANSWER_START,
  };
};
const answerSuccessAction = (payload: AnswerDto): AnswerSuccessAction => {
  return {
    type: ANSWER_SUCCESS,
    payload: payload,
  };
};
const answerFailAction = (error: ErrorDto): AnswerFailAction => {
  return {
    type: ANSWER_FAIL,
    error: error,
  };
};
const answerResetAction = (): AnswerResetAction => {
  return {
    type: ANSWER_RESET,
  };
};

export const answer =
  (request: AnswerRequest, isEtkApproved: boolean = false) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(answerStartAction());
      if (isEtkApproved) {
        await acceptEtkRequest().catch(() => {
          // not an epic fail.
        });
      }
      const response = await answerRequest(request);
      dispatch(answerSuccessAction(response));
    } catch (error) {
      if (isEtkApproved) {
        await getMeRequest(dispatch); // refresh me for etk
      }
      dispatch(answerFailAction(Errors.getErrorDtoFromApiError(error)));
    }
  };

export const answerReset = () => (dispatch: Dispatch) => {
  dispatch(answerResetAction());
};
